import { FEATURE_PAGE_PATHS, type FeaturePageFamily } from "./featurePagePaths";

const FEATURE_PAGE_FAMILY_BY_PATH = Object.fromEntries(
  Object.entries(FEATURE_PAGE_PATHS).map(([family, path]) => [path.slice(1), family]),
) as Record<string, FeaturePageFamily>;

export function parseFeaturePageFamilyPath(value: unknown): FeaturePageFamily | null {
  return typeof value === "string" ? (FEATURE_PAGE_FAMILY_BY_PATH[value] ?? null) : null;
}
